import aboutBackground from '../assets/about-background.jpg';
// Import team photos
import christianPhoto from '../assets/team/christian-packer.jpg';
import brycePhoto from '../assets/team/bryce-roberts.jpg';
import williamPhoto from '../assets/team/william-hoover.jpg';
import katiePhoto from '../assets/team/katie-thiele.jpg';
import alessondraPhoto from '../assets/team/alessondra-bowerson.jpg';

export default function About() {
  const teamMembers = [
    {
      name: 'Christian Packer',
      role: 'Chairman',
      image: christianPhoto,
      bio: 'Christian leads MANE with a passion for clean energy solutions and sustainable nuclear technology. As a sophomore in Nuclear Engineering, he brings drive and a commitment to advancing energy policy on campus.'
    },
    {
      name: 'Bryce Roberts',
      role: 'Vice-Chair',
      image: brycePhoto,
      bio: 'Bryce supports organizational leadership and coordinates our outreach initiatives. As a nuclear engineering major studying materials at the University, he focuses on connecting students with industry professionals and organizing educational events.'
    },
    {
      name: 'William Hoover',
      role: 'Treasurer',
      image: williamPhoto,
      bio: 'William manages MANE\'s finances and ensures our events run smoothly. As the treasurer for multiple organizations on campus, he brings a unique perspective on the economic benefits of nuclear energy.'
    },
    {
      name: 'Katie Thiele',
      role: 'Secretary',
      image: katiePhoto,
      bio: 'Katie keeps our organization organized and our communications clear. Studying Nuclear Engineering, she is passionate about science communication and making nuclear ideas accessible to all students on campus.'
    },
    {
      name: 'Alessondra Bowerson',
      role: 'Social Chair',
      image: alessondraPhoto,
      bio: 'Alessondra plans our social events and builds community within MANE. As a policy focused engineering major, she creates engaging experiences that bring together students from all backgrounds to learn about nuclear energy.'
    }
  ];

  return (
    <section className="pt-24 py-16 px-4 sm:px-6 lg:px-8 bg-white min-h-screen relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10"
        style={{ backgroundImage: `url(${aboutBackground})` }}
      />
      <div className="absolute inset-0 bg-white opacity-20" />
      
      {/* Content */}
      <div className="max-w-7xl mx-auto relative z-10 w-full">
        <h2 
          className="text-4xl font-bold text-michigan-blue mb-8 text-center"
          data-aos="fade-down"
        >
          About Us
        </h2>
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div 
            className="bg-blue-50 p-8 rounded-xl border-2 border-michigan-blue"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            <h3 className="text-2xl font-semibold text-michigan-blue mb-4">Our Mission</h3>
            <p className="text-gray-700 leading-relaxed">
              Michigan Advocates for Nuclear Energy is a student organization dedicated to educating the University of Michigan community about the benefits and importance of nuclear energy. We believe nuclear power is essential for achieving a sustainable, carbon-free energy future while meeting growing global energy demands.
            </p>
          </div>
          <div 
            className="bg-yellow-50 p-8 rounded-xl border-2 border-michigan-maize"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <h3 className="text-2xl font-semibold text-michigan-blue mb-4">What We Do</h3>
            <p className="text-gray-700 leading-relaxed">
              Through informational booths, guest speakers, and community outreach, we provide opportunities to learn about nuclear technology, policy, and careers. We foster dialogue between students, faculty, industry professionals, and policymakers to advance clean energy solutions.
            </p>
          </div>
        </div>

        {/* Meet the Team Section */}
        <div className="mt-16">
          <h2 
            className="text-4xl font-bold text-michigan-blue mb-12 text-center"
            data-aos="fade-down"
          >
            Meet the Team
          </h2>
          <div className="space-y-8">
            {teamMembers.map((member, idx) => (
              <div 
                key={idx}
                className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-michigan-maize hover:shadow-xl transition"
                data-aos="fade-up"
                data-aos-delay={idx * 100}
              >
                <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                  {/* Photo */}
                  <div className="flex-shrink-0">
                    <img 
                      src={member.image} 
                      alt={member.name}
                      className="w-32 h-32 rounded-full object-cover border-4 border-michigan-blue shadow-md"
                    />
                  </div>
                  
                  {/* Info */}
                  <div className="flex-grow text-center md:text-left">
                    <h3 className="text-2xl font-bold text-michigan-blue">{member.name}</h3>
                    <p className="text-michigan-maize font-semibold text-lg mb-3">{member.role}</p>
                    <p className="text-gray-700 leading-relaxed">{member.bio}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
